import React from "react";
import { Pagination } from "react-bootstrap";

const ClientPagination = ({
  currentPage,
  totalPages,
  paginate,
  filteredClients,
  clientsPerPage,
  indexOfFirstClient,
  indexOfLastClient,
}) => {
  const pageNumbers = [];
  const maxVisiblePages = 5;

  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

  if (endPage - startPage + 1 < maxVisiblePages) {
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="d-flex justify-content-between align-items-center mt-3">
      <div className="pagination-info">
        Showing {indexOfFirstClient + 1} to {Math.min(indexOfLastClient, filteredClients.length)} of{" "}
        {filteredClients.length} clients
      </div>
      {totalPages > 1 && (
        <Pagination>
          <Pagination.First
            onClick={() => paginate(1)}
            disabled={currentPage === 1}
          />
          <Pagination.Prev
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          />

          {startPage > 1 && (
            <>
              <Pagination.Item onClick={() => paginate(1)}>1</Pagination.Item>
              {startPage > 2 && <Pagination.Ellipsis />}
            </>
          )}

          {pageNumbers.map((number) => (
            <Pagination.Item
              key={number}
              onClick={() => paginate(number)}
              active={number === currentPage}
            >
              {number}
            </Pagination.Item>
          ))}

          {endPage < totalPages && (
            <>
              {endPage < totalPages - 1 && <Pagination.Ellipsis />}
              <Pagination.Item onClick={() => paginate(totalPages)}>
                {totalPages}
              </Pagination.Item>
            </>
          )}

          <Pagination.Next
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
          <Pagination.Last
            onClick={() => paginate(totalPages)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
      )}
    </div>
  );
};

export default ClientPagination;
